import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email'
import Phone from './Phone'
import DatePickers from './DatePicker'
import DropDown from './DropDown'
import LongText from './LongText'

const ServiceDeskCheckInForm = () => {


    const typeOfServices =
        [
            'تعمیر سخت افزار',
            'پشتیبانی نرم‌افزار',
            'مشکل شبکه',
            'دسترسی به حساب',
            'دیگر'
        ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم ثبت نام میز خدمت'} subHeader={'لطفا برای بررسی درخواست خدمات خود، این فرم را پر کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <Email header={'آدرس ایمیل'} />
                <Phone header={'شماره تلفن'} />
                <DatePickers header={'تاریخ درخواست خدمات'} />
                <DropDown header={'نوع خدمات مورد نیاز'} options={typeOfServices} />
                <LongText header={'شرح مسئله'} />
            </Grid>
        </Grid>
    )
}

export default ServiceDeskCheckInForm
